import React from 'react';
import { connect } from 'react-redux';

import { CardElement } from '@stripe/react-stripe-js';

import { cardElementChange } from '../reducer';

export class CardView extends React.Component {

    onCardChange = (card) => {
        this.props.onCardChange(card);
    }

    render() {
        return (
            <div className="required field">
                {
                    this.props.showHeader &&
                    <label className="card-header">Credit details</label>
                }
                <CardElement className="card-element" id="card"
                    onChange={this.onCardChange}
                    options={{
                        hidePostalCode: true,
                        style: { base: { fontFamily: "Lato", fontSize: "16px" } },
                    }}
                />
                {
                    this.props.errorMessage &&
                    <p className="c-error">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

const mapState = (state) => {
    return {
        errorMessage: state.donation.cardErrorMessage
    };
};

const mapDispatch = (dispatch, _ownProps) => {
    return {
        onCardChange: (card) => {
            dispatch(cardElementChange(card));
        },
    };
};

const Card = connect(mapState, mapDispatch)(CardView);
export default Card;